import { FC, useEffect } from "react";
import { Router } from "next/router";
import {
  ENABLE_TRACKING_SCRIPTS,
  useFacebookPixelScript,
} from "~features/tracking/trackingConfig";
import { useCookieConsent } from "~context/cookieConsentContext";
import { pageviewFBWithConsent } from "~features/tracking/consentAwareTracking";

interface FacebookPixelScriptProps {
  pixelId?: string;
  router?: Router;
}

export const FacebookPixelScript: FC<FacebookPixelScriptProps> = ({
  pixelId,
}) => {
  const { isMarketingAllowed } = useCookieConsent();

  if (isMarketingAllowed() && pixelId) {
    useFacebookPixelScript(pixelId);
  }
  return null;
};

export const FacebookPixelRouteTracker: FC<FacebookPixelScriptProps> = ({
  pixelId,
  router,
}) => {
  const { isMarketingAllowed } = useCookieConsent();

  useEffect(() => {
    if (!router || !pixelId || !isMarketingAllowed()) return;

    const handleRouteChange = () => {
      if (ENABLE_TRACKING_SCRIPTS && isMarketingAllowed()) {
        pageviewFBWithConsent(pixelId);
      }
    };

    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router?.events, pixelId, router, isMarketingAllowed]);

  return null;
};
